export const crisp = {
  CRISP_URL: 'https://client.crisp.chat',
  CRISP_WSS: 'wss://client.relay.crisp.chat',
  CRISP_IMG: 'https://image.crisp.chat',
  CRISP_FILES: 'https://storage.crisp.chat',
  CRISP_STREAM: 'wss://stream.relay.crisp.chat',
};
